import { objectsRHandler } from '@/utils/objectsRHandler';

import Exhibition from '../list/exhibition';
import ExhibitionHall from '../list/exhibition-hall';
import Exposition from '../list/exhibition-hall-exposition';
import ExhibitionTag from '../list/exhibition-tag';

const API_PATH = 'exhibitions';
const API_PATH_HALL = 'exhibition-halls';
const API_PATH_EXPOSITION = 'exhibition-expositions';
const API_PATH_TAG = 'exhibition-tags';

export const ExhibitionsManager = {
  objects: objectsRHandler(API_PATH, Exhibition),
  halls: objectsRHandler(API_PATH_HALL, ExhibitionHall),
  get expositions() {
    return {
      ...objectsRHandler(API_PATH_EXPOSITION, Exposition),
      create: ({ args, ...other }) => {
        const [hallId] = args;
        const API_PATH_FOR_CREATE = `${API_PATH_HALL}/${hallId}/expositions`;
        const { create } = objectsRHandler(API_PATH_FOR_CREATE, Exposition);
        return create(other);
      },
    };
  },
  tags: objectsRHandler(API_PATH_TAG, ExhibitionTag),
};
